"use strict";

exports.__esModule = true;
exports.ViewSize = exports.PlayerEvent = exports.PlaybackEventHandler = void 0;
var _PlaybackPolicy2 = require("./PlaybackPolicy");
var _TimedMetadata = require("./TimedMetadata");
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); } /*
 * COPYRIGHT 2020-2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */ // JsDoc/TS imports
/**
 * Enumeration of possible player events:
 * @category Enumerations
 * @enum {number}
 */
var PlayerEvent = exports.PlayerEvent = Object.freeze({
  /** Indicates that playback started. A client must send the `STOP` event when playback stops. */
  START: 0,
  /** Indicates that playback stopped and the stream will no longer be played */
  STOP: 1,
  /** Indicates that playback paused. A client must send the `RESUME` event when playback resumes. */
  PAUSE: 2,
  /** Indicates that playback resumed after pausing */
  RESUME: 3,
  /** Indicates that playback stalled as a result of buffering. A client must send the `CONTINUE` event when playback stops buffering. */
  STALL: 4,
  /** Indicates that playback continued after stalling */
  CONTINUE: 5,
  /** Indicates that the user rewound the advert */
  ADVERT_REWIND: 6,
  /** Indicates that the user pressed the skip button for a skippable advert */
  ADVERT_SKIP: 7,
  /** Indicates that playback seeked to a new position */
  SEEK: 8,
  /** Indicates that playback is ready but not yet started */
  PLAYBACK_READY: 9
});

/**
 * Enumeration of possible viewport sizes for the video screen:
 * @category Enumerations
 * @enum {number}
 */
var ViewSize = exports.ViewSize = Object.freeze({
  /** Indicates that the viewport was collapsed */
  COLLAPSED: 0,
  /** Indicates that the viewport was expanded */
  EXPANDED: 1
});

/**
 * PlaybackEventHandler declares a set of callback methods that allow clients to provide information
 * about the state of playback to the SDK.
 *
 * It is implemented by the Session-derived instance and clients <b>must</b> call each method at the
 * appropriate time so that the Session can signal analytics on behalf of the app.
 * @hideconstructor
 */
var PlaybackEventHandler = exports.PlaybackEventHandler = /*#__PURE__*/function (_PlaybackPolicy) {
  _inheritsLoose(PlaybackEventHandler, _PlaybackPolicy);
  function PlaybackEventHandler() {
    return _PlaybackPolicy.apply(this, arguments) || this;
  }
  var _proto = PlaybackEventHandler.prototype;
  /** Indicates that a playback event occurred, for example playback started, stopped, paused.
   * volume are fired by the framework.
   @param {PlayerEvent} event the event, defined by the enum PlayerEvent
   @param {number} playhead the playhead position when the event occurred, in milliseconds
   @see {@link PlayerEvent}
   */
  _proto.onPlayerEvent = function onPlayerEvent(event, playhead) {
    throw new Error("Function must be overridden");
  }

  /** Indicates that a playback position update occurred. Clients should call this method at a regular
   * cadence, for example every 200ms, to enable accurate analytics and timing in the SDK.
   @param {number} playhead the playhead position when the event occurred, in milliseconds
   */;
  _proto.onPlayheadUpdate = function onPlayheadUpdate(playhead) {
    throw new Error("Function must be overridden");
  }

  /** Indicates that timed metadata was collected from the stream. During playback of a linear stream
   * clients must call this method on receiving timed metadata events from the player - as a result
   * of ID3 tags (HLS) or EMSG (DASH).
   @param {TimedMetadata} metadata a timed metadata object representing the data from the stream
   @see {@link TimedMetadata}
   */;
  _proto.onTimedMetadata = function onTimedMetadata(metadata) {
    throw new Error("Function must be overridden");
  }

  /** Indicates that the player viewport size changed.
   @param {ViewSize} size The new player viewport size.
   @see {@link ViewSize}
   */;
  _proto.onViewSizeChange = function onViewSizeChange(size) {
    throw new Error("Function must be overridden");
  }

  /** Indicates that playback volume was muted or unmuted. Any tracking events associated with
   * volume are fired by the framework.
   @param {boolean} muted true if the volume was muted, false otherwise.
   */;
  _proto.onVolumeChange = function onVolumeChange(muted) {
    throw new Error("Function must be overridden");
  };
  return PlaybackEventHandler;
}(_PlaybackPolicy2.PlaybackPolicy);